export default "__VITE_ASSET__TSFdnLVx__"